import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { caseStudies, caseStudyCategories } from "../../data/caseStudies";
import { liveSessions } from "../../data/liveSessions";
import { Comments } from "../../Components/common/Comments/Comments";
import { SearchFilterBar } from "../../Components/ui/SearchFilterBar/SearchFilterBar";
import aboutusBg from "../../assets/images/aboutus-bg.png";
import { VideoCard } from "../../Components/ui/VideoCard/VideoCard";
import "./CasestudyDetails.css";
import doctorAvatar from "../../assets/images/docter-profile.png";

const sampleComments = [
  {
    id: 1,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 2,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 3,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 4,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 5,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 6,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
];

export const CasestudyDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");

  const cs = caseStudies.find((c) => c.slug === slug);

  if (!cs) {
    return (
      <div className="csd-not-found">
        <p>Case study not found.</p>
        <Button onClick={() => navigate("/case-studies")}>
          Back to Case Studies
        </Button>
      </div>
    );
  }
  const relatedVideos = liveSessions.slice(0, 3);

  const paragraphs = cs.content.split("\n\n");

  return (
    <div className="csd-page">
      {/* Hero */}
      <section
        className="store-page__hero"
        style={{ backgroundImage: `url(${aboutusBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">Case Study Knowledge</p>
            <h1 className="store-page__hero-title">
              Connecting Doctor to trusted care worldwide and seamless support.
            </h1>
          </Container>
        </div>
      </section>

      {/* Search + Filter toolbar */}
      <SearchFilterBar
        value={search}
        onChange={setSearch}
        filterOptions={caseStudyCategories}
        activeFilter={activeCategory}
        onFilterChange={(cat) => {
          setActiveCategory(cat);
          const match = caseStudies.find(
            (c) => cat === "All" || c.category === cat,
          );
          if (match) navigate(`/case-studies/${match.slug}`);
        }}
      />

      {/* Article body */}
      <section className="csd-body">
        <Container>
          <div className="csd-body__hero-img-wrap">
            <img src={cs.image} alt={cs.title} className="csd-body__hero-img" />
          </div>

          <h2 className="csd-body__title">{cs.title}</h2>

          {paragraphs.map((para, idx) => (
            <div key={idx}>
              <p className="csd-body__para">{para}</p>
              {idx === 1 && (
                <div className="csd-body__mid-img-wrap">
                  <img
                    src={cs.midImage}
                    alt="case study mid"
                    className="csd-body__mid-img"
                  />
                </div>
              )}
            </div>
          ))}
        </Container>
      </section>

      {/* Comments + You Also Like */}
      <section className="cme-bottom">
        <Container>
          <Row className="g-5">
            {/* Left — Comments */}
            <Col xs={12} lg={7}>
              <Comments comments={sampleComments} authorAvatar={doctorAvatar} />
            </Col>

            {/* Right — You Also Like */}
            <Col xs={12} lg={5}>
              <h3 className="cme-related__heading">You also Like</h3>
              <div className="cme-related__list">
                {relatedVideos.map((card) => (
                  <VideoCard key={card.id} {...card} />
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};
